import API from 'services/API';

export default function checkExistingKbk(code) {
  return API.request({
    method: 'GET',
    url: `/dicts/kbk/validate`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      kbk: code,
    },
  });
}
